<template>
  <v-list-item :to="to" :title="title" link nav :prepend-icon="icon" />
</template>
<script setup lang="ts">
  defineProps({
    title: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    to: {
      type: String,
      required: true,
    },
  });
</script>
